import t from '@rcm/i18n-client';
import { AxiosResponse } from 'axios';

const ERROR_TEXT = {
    403: {
        bodyError:
            'You may not have permission to perform that action. ' +
            'If you believe this is a mistake, please contact an ' +
            'administrator.',
        headingError: 'Permission Denied',
    },
    500: {
        bodyError: null,
        headingError: 'Internal Server Error',
    },
};

const DEFAULT_ERROR_TEXT = {
    bodyError: null,
    headingError: 'An error occurred',
};

export default function getErrorText(e: Error & { response: AxiosResponse }) {
    const statusCode = e?.response?.status;
    const text = ERROR_TEXT[statusCode] || DEFAULT_ERROR_TEXT;
    return {
        bodyError: text.bodyError ? t(text.bodyError) : null,
        headingError: t(text.headingError),
    };
}
